import React, { Component } from 'react';

export class Footer extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    addressLine(line) {
        if (line) {
            return <span>{line}<br/></span>;
        }
    }

    slawAddressLine(line) {
        if (line) {
            return <span>,&nbsp;{line}</span>;
        }
    }


    termsLink() {
        let termsUrl = `https://${this.props.quoteData.brandUrl}/${this.props.quoteData.brandTermsPage}`;

        return (<span className="small text-muted hidden-print">View our<a target="_blank" rel="noopener noreferrer" href={termsUrl}>Terms and Conditions</a></span>);
    }

    renderOld() {
        if (this.props.quoteData.brandId === 220005) {
            return (this.renderSlaw());
        }

        return (
            <div className="row">
                <div className="col-md-12">
                    <hr />
                </div>
                <div className="col-md-3">
                    <address className="text-muted small">
                        <strong>{this.props.quoteData.brandName}</strong><br />
                        {this.addressLine(this.props.quoteData.brandAddress1)}
                        {this.addressLine(this.props.quoteData.brandAddress2)}
                        {this.addressLine(this.props.quoteData.brandAddress3)}
                        {this.addressLine(this.props.quoteData.brandTownCity)}
                        {this.addressLine(this.props.quoteData.brandCounty)}
                        {this.addressLine(this.props.quoteData.brandPostcode)}
                        Registered in England No. {this.props.quoteData.brandCompanyNo}<br />
                        VAT No. {this.props.quoteData.brandVatReg}
                    </address>
                </div>
                <div className="col-md-3 col-md-offset-6">
                    {this.termsLink()}
                </div>
            </div>
        );
    }

    renderOnline() {
        return (
            <div className="row" style={{ margin: '0' }}>
                <style>
                    {`.btn-primary,
                    .btn-primary:hover,
                    .btn-primary:active,
                    .btn-primary:visited,
                    .btn-primary:focus,
                    .btn-success.disabled,
                    .btn-success.disabled:hover,
                    .btn-success.disabled:active,
                    .btn-success.disabled:visited,
                    .btn-success:focus{
                        background-color: #00a48a;
                        border-color: #00a48a;
                        background-image: none;
                        }!important`
                    }
                </style>
                <div className="col-md-12">
                    <div className="row" style={{ margin: '50px 0 0 0', fontSize: '12px' }}>
                        <div className="col-md-6 panel panel-default" style={{ padding: '10px 10px 20px 10px' }}>
                            <strong>More Great Reasons to Book with Us</strong><br />
                            <ul>
                                <li>Make huge savings with our course bundles.</li>
                                <li>Monitor user progress with our Learner Management System.</li>
                                <li>24/7 access.</li>
                            </ul>
                            <strong>Why not join our Key Account Service?</strong><br />
                            Earn discounts on future courses and have your own
                            dedicated Account Manager
                        </div>
                    </div>
                </div>

                <div className="row" style={{ margin: '30px 0 0 -4px' }}>
                    <div className="col-md-12 small" style={{ fontSize: '12px', padding: '0' }}>
                        <img src=".\.\img\widget-icon-circle-firstaid.png" alt="First aid" /><span style={{ color: 'green' }}>First Aid Training Courses&nbsp;&nbsp;</span>
                        <img src=".\.\img\widget-icon-circle-health.png" alt="Health" /><span style={{ color: 'darkmagenta' }}>Health and Safety Courses&nbsp;&nbsp;</span>
                        <img src=".\.\img\widget-icon-circle-fire.png" alt="Fire" /><span style={{ color: 'red' }}>Fire Safety Training Courses&nbsp;&nbsp;</span>
                        <img src=".\.\img\widget-icon-circle-safeguarding.png" alt="Safeguarding" /><span style={{ color: 'gray' }}>Safeguarding Training Courses&nbsp;&nbsp;</span>
                        <img src=".\.\img\widget-icon-circle-food.png" alt="Food" /><span style={{ color: 'lightblue' }}>Food Safety Training Courses&nbsp;&nbsp;</span>
                    </div>
                </div>

                <div className="row" style={{ margin: '30px 0 0 0', fontSize: '10px' }}>
                    <div className="col-md-6" style={{ padding: '0' }}>
                        <span className="small">
                            {this.props.quoteData.brandName}
                            {this.slawAddressLine(this.props.quoteData.brandAddress1)}
                            {this.slawAddressLine(this.props.quoteData.brandAddress2)}
                            {this.slawAddressLine(this.props.quoteData.brandAddress3)}
                            {this.slawAddressLine(this.props.quoteData.brandTownCity)}
                            {this.slawAddressLine(this.props.quoteData.brandCounty)}
                            {this.slawAddressLine(this.props.quoteData.brandPostcode)}<br />
                            Part of the Training at Work Group
                        </span>
                    </div>
                    <div className="col-md-6 text-right" style={{ padding: '0' }}>
                        <span className="small text-right">Registered in England No. {this.props.quoteData.brandCompanyNo}<br />VAT No. {this.props.quoteData.brandVatReg}</span>
                    </div>
                </div>


                <div className="row" style={{ margin: '10px 0 0 0', fontSize: '10px' }}>
                    <div className="col-md-3" style={{ padding: '0' }} >
                        {this.termsLink()}
                    </div>
                </div>
            </div>
        );
    }

    renderOnsite() {
        return (
            <div className="row" style={{ margin: '0' }}>
                <style>
                    {`.btn-primary,
                    .btn-primary:hover,
                    .btn-primary:active,
                    .btn-primary:visited,
                    .btn-primary:focus,
                    .btn-success.disabled,
                    .btn-success.disabled:hover,
                    .btn-success.disabled:active,
                    .btn-success.disabled:visited,
                    .btn-success:focus{
                        background-color: #00a48a;
                        border-color: #00a48a;
                        background-image: none;
                        }!important`
                    }
                </style>
                <div className="col-md-12">
                    <div className="row" style={{ margin: '50px 0 0 0', fontSize: '12px' }}>
                        <div className="col-md-6 panel panel-default" style={{ padding: '10px 10px 20px 10px' }}>
                            <strong>More Great Reasons to Book with Us</strong><br />
                            <ul>
                                <li>Price match guarantee on all courses – just tell us where you’ve seen the same course cheaper.</li>
                                <li>OFQUAL accreditation on ALL First Aid courses.</li>
                                <li>Trainers come to you or choose from one of 180 training venues throughout the country.</li>
                            </ul>
                            <strong>Why not join our Key Account Service?</strong><br />
                            Earn discounts on future courses and have your own
                            dedicated Account Manager
                        </div>
                    </div>
                </div>
                <div className="row" style={{ margin: '0' }}>
                    <div className="col-md-4">
                        <img src=".\.\img\ofqual-logo-1024x227.png" alt="Ofqual" /><br />
                        <span className="small">*OFQUAL only related to RQF qualifications</span>
                    </div>
                </div>

                <div className="row" style={{ margin: '30px 0 0 -4px' }}>
                    <div className="col-md-12 small" style={{ fontSize: '12px', padding: '0' }}>
                        <img src=".\.\img\widget-icon-circle-firstaid.png" alt="First aid" /><span style={{ color: 'green' }}>First Aid Training Courses&nbsp;&nbsp;</span>
                        <img src=".\.\img\widget-icon-circle-health.png" alt="Health" /><span style={{ color: 'darkmagenta' }}>Health and Safety Courses&nbsp;&nbsp;</span>
                        <img src=".\.\img\widget-icon-circle-fire.png" alt="Fire" /><span style={{ color: 'red' }}>Fire Safety Training Courses&nbsp;&nbsp;</span>
                        <img src=".\.\img\widget-icon-circle-safeguarding.png" alt="Safeguarding" /><span style={{ color: 'gray' }}>Safeguarding Training Courses&nbsp;&nbsp;</span>
                        <img src=".\.\img\widget-icon-circle-food.png" alt="Food" /><span style={{ color: 'lightblue' }}>Food Safety Training Courses&nbsp;&nbsp;</span>
                    </div>
                </div>

                <div className="row" style={{ margin: '30px 0 0 0', fontSize: '10px' }}>
                    <div className="col-md-6" style={{ padding: '0' }}>
                        <span className="small">
                            {this.props.quoteData.brandName}
                            {this.slawAddressLine(this.props.quoteData.brandAddress1)}
                            {this.slawAddressLine(this.props.quoteData.brandAddress2)}
                            {this.slawAddressLine(this.props.quoteData.brandAddress3)}
                            {this.slawAddressLine(this.props.quoteData.brandTownCity)}
                            {this.slawAddressLine(this.props.quoteData.brandCounty)}
                            {this.slawAddressLine(this.props.quoteData.brandPostcode)}<br />
                            Part of the Training at Work Group
                        </span>
                    </div>
                    <div className="col-md-6 text-right" style={{ padding: '0' }}>
                        <span className="small text-right">Registered in England No. {this.props.quoteData.brandCompanyNo}<br />VAT No. {this.props.quoteData.brandVatReg}</span>
                    </div>
                </div>


                <div className="row" style={{ margin: '10px 0 0 0', fontSize: '10px' }}>
                    <div className="col-md-3" style={{ padding: '0' }} >
                        {this.termsLink()}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (this.props.quoteData.brandId === 220002 || // Food safety at work
            this.props.quoteData.brandId === 220006 || // eLearning at work
            this.props.quoteData.brandId === 220001 || // Fire safety at work
            this.props.quoteData.brandId === 220009 || // Level 3 food hygiene
            this.props.quoteData.brandId === 220000 || // Manual handling at work
            this.props.quoteData.brandId === 220008 || // Online first aid training
            this.props.quoteData.brandId === 220007    // Online asbestos awareness
            ) {
            return(this.renderOnline());
        } else {
            return(this.renderOnsite());
        }
    }
}